import { TLessonNativeSize } from './parseLessonProjectMetadata';

export type TLessonDisplaySize = {
  scale: number;
  width: number;
  height: number;
};

export const getLessonDisplaySize = (containerWidth: number, lessonSize: TLessonNativeSize): TLessonDisplaySize => {
  if (containerWidth <= 0 || lessonSize.width <= 0 || lessonSize.height <= 0) {
    return { scale: 0, width: 0, height: 0 };
  }

  const scale = Math.min(1, containerWidth / lessonSize.width);

  return {
    scale,
    width: lessonSize.width * scale,
    height: lessonSize.height * scale,
  };
};
